import * as React from 'react';
import { AlertCircle } from 'lucide-react';
import { Label } from './label.js';

export interface FormFieldProps {
  label: string;
  required?: boolean;
  error?: string;
  testId: string;
  /** Associates the label with an input by id — sets htmlFor on the rendered <label> */
  htmlFor?: string;
  children: React.ReactNode;
}

function FormField({ label, required, error, testId, htmlFor, children }: FormFieldProps) {
  return (
    <div className="space-y-1.5" data-testid={testId}>
      <Label required={required} htmlFor={htmlFor}>
        {label}
      </Label>
      {children}
      {error ? (
        <p
          className="text-[11px] text-destructive flex items-center gap-1"
          data-testid={`${testId}-error`}
        >
          <AlertCircle className="h-3 w-3 shrink-0" />
          {error}
        </p>
      ) : null}
    </div>
  );
}

export { FormField };
